import { AuthHelper } from '../../utils/auth_helper';
import { SellerBidListingForEmpForm } from "../../components/emp/SellerBidListingForEmpForm";

import React from "react";
import Grid from '@mui/material/Grid';


function SellerBidListingForEmp() {

  return (
    <div>
      <AuthHelper/>
      <div className="tw-px-5 sm:tw-ml-20 tw-text-left">

          
          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Sellers Bid Listing for Employee</p></span>
              </Grid>
            </Grid>

            <SellerBidListingForEmpForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { SellerBidListingForEmp };
